import { PdpWeekDayType } from '@domains/pdp-common';

export enum BusinessEtcDayType {
  WEEKEND = 'WEEKEND',
  PUBLIC_HOLIDAY = 'PUBLIC_HOLIDAY',
}

export type BusinessDay = PdpWeekDayType | BusinessEtcDayType;

/**
 * 반환값 TFunction<'products'>로 번역 필요
 */
export const getBusinessDayTransText = (day: BusinessDay) => {
  switch (day) {
    case PdpWeekDayType.MON:
      return '월';
    case PdpWeekDayType.TUE:
      return '화';
    case PdpWeekDayType.WED:
      return '수';
    case PdpWeekDayType.THU:
      return '목';
    case PdpWeekDayType.FRI:
      return '금';
    case PdpWeekDayType.SAT:
      return '토';
    case PdpWeekDayType.SUN:
      return '일';
    case BusinessEtcDayType.WEEKEND:
      return '주말';
    case BusinessEtcDayType.PUBLIC_HOLIDAY:
      return '공휴일';
  }
};
